import { render, staticRenderFns } from "./BackofficeGerarGuias.vue?vue&type=template&id=6ea8a0a6"
import script from "./BackofficeGerarGuias.vue?vue&type=script&lang=ts"
export * from "./BackofficeGerarGuias.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports